import { useEffect, useState } from "react";
import Spinner from "../../../../components/Spinner";
import useFetch from "../../../../hooks/useFetch";

const TabVideo = ({ selectedItem }) => {
  const [videoUrl, setVideoUrl] = useState(null);

  // Use the useFetch hook to get the secure video URL
  //const { data, isLoading, errorMessage, fetchData } = useFetch();

  // useEffect(() => {
  //   if (selectedItem && selectedItem.video_url) {
  //     fetchData(`${process.env.REACT_APP_API_URL}/get-secure-video-url?video_id=${selectedItem.id}`);
  //   }
  // }, [selectedItem, fetchData]);

  // Update video URL if data is fetched
  useEffect(() => {
    if (selectedItem && selectedItem.video_url) {
      setVideoUrl(selectedItem.video_url);  // Update videoUrl state with the fetched signed URL
    }
  }, [selectedItem]);

  // Handle video download
const downloadFileUsingFetch = async (url) => {

  const parsedUrl = new URL(url);
  const path = parsedUrl.pathname;
  const fileName = path.split('/').pop();


  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error("Failed to fetch file");

    const blob = await response.blob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

  return (
    <div className="col-12 mb-md-0 mb-4">
      <div className="card shadow-none">
        {/* VIDEO FILE */}
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <table className="table table-bordered" style={{ borderRadius: 10 }}>
                <tr className="border">
                  <th colSpan={2} className="p-2 bg-label-primary fw-bold fs-6">
                    Video Files
                  </th>
                </tr>
                <tbody>
                  <tr>
                    <td>
                      <div style={{ overflowY: "auto" }}>
                        {selectedItem.video_url ? (
                          <video
                            className="w-100"
                            poster="https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.jpg"
                            id="plyr-video-player"
                            playsinline
                            controls
                          >
                            <source src={videoUrl || selectedItem.video_url} type="video/mp4" />
                          </video>
                        ) : (
                          <p>No video available</p>
                        )}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              {/* Download Button */}
              {videoUrl && (
                <div className="text-center mt-3">
                   <button type="button" className="btn btn-primary" onClick={() => { 
                    if(videoUrl){
                      downloadFileUsingFetch(videoUrl); 
                    } else{
                       alert("No valid video URL!"); } 
                    }}>
                      Download Video
                    </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabVideo;
